import React from 'react';
import { useFormikContext } from 'formik';
import { AphTextInput, AphButton } from '@aph/common-react';
import { IoSearchOutline } from 'react-icons/io5';

import { SearchFormType } from 'global.types';
import { updateUrlSearchParameters } from 'global.helpers';

import './SearchBar.scss';

// Name of the enter key to track it in the keydown event
const enterKeyCode = 'Enter';

/**
 * ISearchBar
 *
 * @description Component properties for Search bar component
 * @property {SearchFormType} theme     Theme
 * @property {string}         name      Field name
 * @property {boolean}        showClear Show clear
 */
interface ISearchBar {
  theme: SearchFormType;
  name: string;
  showClear?: boolean;
}

/**
 * SearchBar
 *
 * @description Search bar used for entering keyword search
 */
const SearchBar: React.FC<ISearchBar> = ({ theme, name, showClear }) => {
  const { submitForm } = useFormikContext();

  return (
    <div className='library-search-bar'>
      <div className={`library-search-bar__inner library-search-bar__inner--${theme}`}>
        <AphTextInput
          as='input'
          name={name}
          placeholder='Search by title or topic'
          onChange={(value: string) => updateUrlSearchParameters(name, value)}
          onKeyDown={e => {
            // If the enter key is clicked then submit the form
            // Unsure why this isn't working by default since this is generally default HTML behaviour
            if (e.code === enterKeyCode && submitForm) {
              submitForm();
            }
          }}
        />
        <AphButton
          as='primary'
          icon={<IoSearchOutline />}
          className='library-search-bar__button library-search-bar__button--search'
          htmlType='submit'
        >
          Search
        </AphButton>
      </div>
      {
        showClear && 
          <AphButton
            as='default'
            className='library-search-bar__button library-search-bar__button--clear'
            htmlType='reset'
          >
            Clear
          </AphButton>
      }
    </div>
  );
};

export default SearchBar;